import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[app-content]'
})
export class ContentDirective {
    @Input() componentName: string;

    constructor() {
    }
}
